/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';

/**
 * Paginated list of tournament teams
 * @export
 * @interface TournamentTeamsListResponse
 */
export interface TournamentTeamsListResponse {
    /**
     * 
     * @type {Array<TournamentTeamResponse>}
     * @memberof TournamentTeamsListResponse
     */
    teams: Array<TournamentTeamResponse>;
    /**
     * Total number of teams
     * @type {number}
     * @memberof TournamentTeamsListResponse
     */
    total: number;
}

/**
 * Check if a given object implements the TournamentTeamsListResponse interface.
 */
export function instanceOfTournamentTeamsListResponse(value: object): value is TournamentTeamsListResponse {
    if (!('teams' in value) || value['teams'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function TournamentTeamsListResponseFromJSON(json: any): TournamentTeamsListResponse {
    return TournamentTeamsListResponseFromJSONTyped(json, false);
}

export function TournamentTeamsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(TournamentTeamResponseFromJSON)),
        'total': json['total'],
    };
}

export function TournamentTeamsListResponseToJSON(json: any): TournamentTeamsListResponse {
    return TournamentTeamsListResponseToJSONTyped(json, false);
}

export function TournamentTeamsListResponseToJSONTyped(value?: TournamentTeamsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teams': ((value['teams'] as Array<any>).map(TournamentTeamResponseToJSON)),
        'total': value['total'],
    };
}

